module.exports = __webpack_public_path__ + "img/hr.7bd313de.png";